/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { PracticeStrictHttpResponse } from '../../practice-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PatientModelSearchResultModel } from '../../models/patient-model-search-result-model';
import { SearchRequestModel } from '../../models/search-request-model';

export interface PatientClinicGroupIdPatientSearchPost$Params {
  clinicGroupId: string;
      body?: SearchRequestModel
}

export function patientClinicGroupIdPatientSearchPost(http: HttpClient, rootUrl: string, params: PatientClinicGroupIdPatientSearchPost$Params, context?: HttpContext): Observable<PracticeStrictHttpResponse<PatientModelSearchResultModel>> {
  const rb = new RequestBuilder(rootUrl, patientClinicGroupIdPatientSearchPost.PATH, 'post');
  if (params) {
    rb.path('clinicGroupId', params.clinicGroupId, {});
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as PracticeStrictHttpResponse<PatientModelSearchResultModel>;
    })
  );
}

patientClinicGroupIdPatientSearchPost.PATH = '/Patient/{clinicGroupId}/PatientSearch';
